import { render, staticRenderFns } from "./Catchs.vue?vue&type=template&id=6ded727e"
import script from "./Catchs.vue?vue&type=script&lang=js"
export * from "./Catchs.vue?vue&type=script&lang=js"
import style0 from "./Catchs.vue?vue&type=style&index=0&id=6ded727e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports